module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "powerReq",
      "label": "Requires"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Power Kw/H",
      "disabled": !this.isEdit
    },
    model: {
      value: (_vm.power.powerReq),
      callback: function($$v) {
        _vm.$set(_vm.power, "powerReq", $$v)
      },
      expression: "power.powerReq"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("Kw/H")])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e84ec1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/features/Power.vue
// module id = 1477
// module chunks = 0